import { render, staticRenderFns } from "./AuthorizedSignatureView.vue?vue&type=template&id=c80f4ef8&scoped=true"
import script from "./AuthorizedSignatureView.vue?vue&type=script&lang=js"
export * from "./AuthorizedSignatureView.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedSignatureView.vue?vue&type=style&index=0&id=c80f4ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80f4ef8",
  null
  
)

export default component.exports